@if (target) {
  <app-confirm-action-modal
    title="Start Family Plan"
    confirmLabel="Start Family"
    busyLabel="Starting..."
    cancelButtonClass="btn-outlined"
    [busy]="busy"
    [confirmDisabled]="!canConfirm"
    [closeOnOverlayClick]="false"
    [mobileSheet]="false"
    testId="start-family-modal"
    (confirm)="onConfirm()"
    (cancel)="cancel.emit()"
  >
    <div class="start-family">
      <dl class="start-family__summary">
        <div>
          <dt>Vehicle</dt>
          <dd data-testid="start-family-plate">{{ target.plate || '-' }}</dd>
        </div>
        <div>
          <dt>Membership</dt>
          <dd data-testid="start-family-package">{{ target.packageName }}</dd>
        </div>
      </dl>

      @if (loading) {
        <p class="start-family__hint" data-testid="start-family-loading">
          Checking this membership...
        </p>
      }

      @if (preview?.eligible) {
        <p class="start-family__hint">
          This membership becomes the primary of a new family and keeps its package, price, card and
          payment date. The family discount applies to added members only. Nothing is charged.
        </p>
      }

      @if (reasonMessage) {
        <p class="start-family__error" role="alert" data-testid="start-family-error">
          {{ reasonMessage }}
        </p>
      }
    </div>
  </app-confirm-action-modal>
}
